"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _portal = _interopRequireDefault(require("./portal"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledPortal = (0, _styledComponents.default)(_portal.default)`
  position: absolute;
  top: 0;
  z-index: 1002;
`;
var _default = StyledPortal;
exports.default = _default;